import { Modal } from 'react-bootstrap'
import { useState, useRef } from 'react'
import { useSettings, useLoaded, resetSettings } from 'Settings'
import { row_content, regValues } from 'Export/ExportC'
import { setSettings, ValueError } from './ImportJson'
import LegacyImport from './ImportLegacy'

import { TYPE } from 'configuration';

const Import = (props) => {
	const [settings] = useSettings()
	const [,setLoaded] = useLoaded()

	const [show, setShow] = useState(false)
	const [fb, setFb] = useState("")
	const [showFb, setShowFb] = useState(false)
	const fileInput = useRef()

	const handleShow = () => setShow(true)
	const handleClose = () => setShow(false)

	const handleImport = () => {
		handleClose()

		let fr = new FileReader()

		fr.onload = () => {
			const ext = fileInput.current.files[0].name.split('.').pop()

			if (ext === 'json') {
				setFb('Import JSON Successful')
				try {
					let json = JSON.parse(fr.result)

					if (json['type'] !== TYPE) {
						setFb(
							<>
								<p>Failed
									<span className="badge bg-danger ms-2">Error</span>
								</p>
								<p>This configuration is for <u>{json['type']}</u> </p>
							</>
						)
					} else {
						delete json['type']
						setSettings(json, settings)
					}
				} catch (e) {
					if (e instanceof ValueError) {
						setFb(<><strong>Error:</strong> <u>{e.value}</u> is not a known Value</>)
					} else if (e instanceof SyntaxError) {
						setFb(e.toString())
					} else {
						throw e
					}
				}
			} else if (ext === TYPE) {
				resetSettings(settings);
				LegacyImport(fr.result, settings)
				setFb(
					<>
					<p>Legacy Import Successful</p>
					<span className="badge bg-warning">Warning</span>
					<p>Although Circular supports legacy imports it is recommended to use the json format</p>
					</>
				)
			}

			setShowFb(true)
			regValues(settings, row_content);
			setLoaded(row_content);
		}

		fr.readAsText(fileInput.current.files[0])
	}

	return (
	<>
			<button className="btn mb-3 menubtn" onClick={handleShow}>
				<span>Open</span>
				<i className="bi bi-upload"></i>
			</button>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header>
					<Modal.Title>Import (.json, .{TYPE})</Modal.Title>
					<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
				</Modal.Header>
				<Modal.Body>
					<input ref={fileInput} className="form-control" type="file" id="formFile" accept={`.json,.${TYPE}`} />
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary" onClick={handleImport}>
						Import
					</button>
				</Modal.Footer>
			</Modal>
			<div style={{
					position: 'absolute',
					bottom: '10px',
					right: '10px',
				}}>
			<Modal onHide={() => setShowFb(false)} show={showFb}>
				<Modal.Header closeButton>
					<strong className="me-auto">Import</strong>
				</Modal.Header>
				<Modal.Body>
					{fb}
				</Modal.Body>
			</Modal>
			</div>
		</>
	)
}

export default Import
